module.exports = {
      id: "AMEX-usage",
      viewBox: "0 0 34 24",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#AMEX-usage",
      toString: function () {
        return this.url;
      }
    }